"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'arbitratorMaintenance',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      name: '',
      //机构名称
      organArr: [],
      //机构数组
      statevalue: '',
      //状态值
      stateArr: [{
        //状态数组
        value: '1',
        label: '已启用'
      }, {
        value: '0',
        label: '已禁用'
      }],
      loading: true,
      total: 0,
      tableData: [],
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      freeVisible: false,
      //添加人员显示
      title: '',
      //弹窗标题
      freeForm: {
        //添加仲裁费数据
        organName: '',
        temName: '',
        state: '启用'
      },
      committeeArr: [],
      //仲裁机构列表
      freeRules: {
        organName: [{
          required: true,
          message: '请选择机构名称'
        }],
        temName: [{
          required: true,
          message: '请输入模板名称'
        }],
        state: [{
          required: true,
          message: '请选择模板状态'
        }]
      },
      freeTableData: [{
        priceMax: '',
        priceMin: '',
        acceptanceType: 2,
        acceptanceFee: '',
        handlingType: 2,
        handlingFree: ''
      }],
      currentRowId: '' //当前仲裁费列表点击的id
    };
  },
  created: function created() {
    var _this = this;
    this.currentPage = 1;
    this.init();
    //仲裁委员会列表
    (0, _configure.getAllCommission)().then(function (res) {
      if (res.code == 1) {
        _this.committeeArr = res.data;
      }
    });
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getChargeList, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getChargeList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 2:
              _yield$getChargeList = _context.sent;
              rows = _yield$getChargeList.rows;
              total = _yield$getChargeList.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getChargeList2, rows, total, _yield$getChargeList3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.name || this.statevalue)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 3;
              return (0, _configure.getChargeList)({
                state: this.statevalue,
                commId: this.name,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getChargeList2 = _context2.sent;
              rows = _yield$getChargeList2.rows;
              total = _yield$getChargeList2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 19;
              break;
            case 11:
              _context2.next = 13;
              return (0, _configure.getChargeList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getChargeList3 = _context2.sent;
              _rows = _yield$getChargeList3.rows;
              _total = _yield$getChargeList3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //添加
    gotoCreate: function gotoCreate() {
      this.freeVisible = true;
      this.title = '添加仲裁费模板';
      if (this.$refs['freeForm']) {
        this.$refs['freeForm'].resetFields();
      }
      this.freeTableData = [{
        priceMax: '',
        priceMin: '',
        acceptanceType: "按百分比(%)",
        acceptanceFee: '',
        handlingType: '固定金额(元)',
        handlingFree: ''
      }];
    },
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getChargeList4, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.total = 1;
              this.currentPage = 1;
              if (!(this.name || this.statevalue)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 5;
              return (0, _configure.getChargeList)({
                state: this.statevalue,
                commId: this.name,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 5:
              _yield$getChargeList4 = _context3.sent;
              rows = _yield$getChargeList4.rows;
              total = _yield$getChargeList4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.statevalue = '';
      this.name = "";
      this.currentPage = 1;
      this.init();
    },
    //表格   编辑
    edit: function edit(val) {
      var _this2 = this;
      this.freeVisible = true;
      this.title = '编辑仲裁费模板';
      if (this.$refs['freeForm']) {
        this.$refs['freeForm'].resetFields();
      }
      this.currentRowId = val.id;
      (0, _configure.checkChargeTemplate)({
        id: val.id
      }).then(function (res) {
        if (res.code == 1) {
          res.data.chargeRulesDtoList.forEach(function (item, index) {
            if (item.acceptanceType == 1) {
              item.acceptanceType = '固定金额(元)';
            } else {
              item.acceptanceType = '按百分比(%)';
            }
            if (item.handlingType == 1) {
              item.handlingType = '固定金额(元)';
            } else {
              item.handlingType = '按百分比(%)';
            }
          });
          var committItem = '';
          committItem = _this2.committeeArr.find(function (ele) {
            return ele.id = res.data.commId;
          });
          _this2.freeForm.temName = res.data.name;
          _this2.freeForm.state = res.data.state == 1 ? '启用' : '禁用';
          _this2.freeForm.organName = committItem.name;
          _this2.freeTableData = res.data.chargeRulesDtoList;
        }
      });
    },
    //修改/添加提交表单
    submitFreeForm: function submitFreeForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid && _this3.freeTableData[0].priceMax >= 0 && _this3.freeTableData[0].priceMin >= 0 && _this3.freeTableData[0].acceptanceFee >= 0 && _this3.freeTableData[0].handlingFree >= 0) {
          var committeeItem = '';
          committeeItem = _this3.committeeArr.find(function (ele) {
            return ele.name == _this3.freeForm.organName;
          });
          // 深复制表单里面表格数据
          var copyFreeTableData = [];
          copyFreeTableData = JSON.parse(JSON.stringify(_this3.freeTableData));
          copyFreeTableData.forEach(function (item, index) {
            if (item.acceptanceType == '固定金额(元)') {
              item.acceptanceType = 1;
            } else {
              item.acceptanceType = 2;
            }
            if (item.handlingType == '固定金额(元)') {
              item.handlingType = 1;
            } else {
              item.handlingType = 2;
            }
          });
          if (_this3.title == '添加仲裁费模板') {
            (0, _configure.addChargeTemplate)({
              name: _this3.freeForm.temName,
              state: _this3.freeForm.state == '启用' ? '1' : '0',
              commId: committeeItem.id,
              chargeRulesDtoList: copyFreeTableData
            }).then(function (res) {
              if (res.code == 1) {
                _this3.$message({
                  message: '添加仲裁费模板成功',
                  type: 'success'
                });
                _this3.freeVisible = false;
                _this3.$refs[formName].resetFields();
                _this3.resetTableList();
              } else {
                _this3.$message.error('已有启用的仲裁费模板数据，不可添加重复仲裁费模板');
              }
            });
          } else {
            (0, _configure.updateChargeTemplate)({
              name: _this3.freeForm.temName,
              state: _this3.freeForm.state == '启用' ? '1' : '0',
              commId: committeeItem.id,
              chargeRulesDtoList: copyFreeTableData,
              id: _this3.currentRowId
            }).then(function (res) {
              if (res.code == 1) {
                _this3.$message({
                  message: '编辑仲裁费模板成功',
                  type: 'success'
                });
                _this3.freeVisible = false;
                _this3.$refs[formName].resetFields();
                _this3.resetTableList();
              } else {
                _this3.$message.error('已有启用的仲裁费模板数据，不可添加重复仲裁费模板');
              }
            });
          }
        } else {
          _this3.$message.error('请完善费用模板');
          return false;
        }
      });
    },
    //弹窗   删除行
    deleteRow: function deleteRow(index, rows) {
      var _this4 = this;
      this.$confirm('是否要移除该行数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        rows.splice(index, 1);
        _this4.$message({
          message: '已移除，请点击确认提交',
          type: 'success'
        });
      });
      if (this.freeTableData.length == 0) {
        this.freeTableData.push({
          priceMax: '',
          priceMin: '',
          acceptanceType: "按百分比(%)",
          acceptanceFee: '',
          handlingType: '固定金额(元)',
          handlingFree: ''
        });
      }
    },
    //弹窗   添加行
    addRows: function addRows() {
      this.freeTableData.push({
        priceMax: '',
        priceMin: '',
        acceptanceType: "按百分比(%)",
        acceptanceFee: '',
        handlingType: '固定金额(元)',
        handlingFree: ''
      });
    },
    // 分页事件
    handleSizeChange: function () {
      var _handleSizeChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(val) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.pageLimit = val;
              this.resetTableList();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleSizeChange(_x) {
        return _handleSizeChange.apply(this, arguments);
      }
      return handleSizeChange;
    }(),
    handleCurrentChange: function () {
      var _handleCurrentChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(val) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.currentPage = val;
              this.resetTableList();
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleCurrentChange(_x2) {
        return _handleCurrentChange.apply(this, arguments);
      }
      return handleCurrentChange;
    }()
  }
};
exports.default = _default;